module.exports = __webpack_public_path__ + "assets/img/elemuic.005c0c38.jpg";